import React from 'react';
import { Plus } from 'lucide-react';
import { Button, type ButtonProps } from './ui/button';
import { cn } from '@/lib/utils';

export const EmptyStateAddButton = React.forwardRef<
  HTMLButtonElement,
  Omit<ButtonProps, 'variant' | 'size'>
>(({ children, className, ...props }, ref) => {
  return (
    <Button
      ref={ref}
      {...props}
      variant="default"
      size="default"
      className={cn('group/empty-state-add-button', className)}
    >
      <Plus className="h-4 w-4 transition-transform duration-500 ease-in-out group-hover/empty-state-add-button:rotate-[360deg]" />
      {children}
    </Button>
  );
});

EmptyStateAddButton.displayName = 'EmptyStateAddButton';
